import { Component } from "@kluntje/core";
import SSOService, { UserObject } from "Services/SSOService";
import { addClass, find, toggleClass } from "@kluntje/js-utils/lib/dom-helpers";

class FRASiteNavigation extends Component {
  SSOService = SSOService.getInstance();
  loggedIn?: boolean;

  constructor() {
    super({
      ui: {
        items: ".fra-m-site-navigation__list-item",
      },
      initialStates: {
        loggedIn: false,
      },
    });
    this.onAuthChange = this.onAuthChange.bind(this);
  }

  /**
   * Lifecycle-Hook: Initializes Component after render
   * @override
   */
  afterComponentRender(): void {
    this.SSOService.subscribe(this.onAuthChange);
    this.markActiveTab();
  }

  markActiveTab() {
    [...this.ui.items].forEach(item => {
      const anchorLink: HTMLAnchorElement | null = find(
        item,
        ".fra-m-site-navigation__link",
      ) as HTMLAnchorElement | null;
      if (
        anchorLink &&
        anchorLink.href.includes("account") &&
        location.href.includes(anchorLink.href.replace(/\.html$/, ""))
      ) {
        addClass(item, "fra-m-site-navigation__list-item--active");
      }
    });
  }

  onAuthChange({ loggedIn }: { loggedIn: boolean; user: UserObject | null }) {
    this.loggedIn = loggedIn;

    toggleClass(this, "fra-state-logged-in", loggedIn);
    toggleClass(this, "fra-state-logged-out", !loggedIn);
  }
}

customElements.define("fra-m-site-navigation", FRASiteNavigation);
